<!-- Layout 4: Text at Top with Background Image -->
<div class="hero-element"
     *ngIf="data?.title || data?.description || data?.buttonText"
     [style.background-image]="getBackgroundImage()"
     [style.background-color]="data?.backgroundColor || '#000000'">
  <div class="hero-content-wrapper">
    <h1 class="hero-title"
        *ngIf="data?.title"
        [style.color]="headingColor || '#FFFFFF'"
        [style.font-family]="headingFont || 'Inter, sans-serif'"
        [ngStyle]="titleStyles">{{ data?.title }}</h1>
    <p class="hero-description"
       *ngIf="data?.description"
       [style.color]="paragraphColor || '#FFFFFF'"
       [style.font-family]="bodyFont || 'Roboto, sans-serif'">
      {{ data?.description }}
    </p>
    <button class="hero-btn" 
            *ngIf="data?.buttonText"
            [style.background-color]="primaryColor || '#FFFFFF'"
            [style.color]="primaryColor ? '#FFFFFF' : '#000000'"
            (click)="onButtonClick(data?.buttonLink, $event)">{{ data?.buttonText }}</button>
  </div>
</div>

